import React from "react";
import { X } from "lucide-react";

export default function ConfirmModal({
  open,
  title = "Conferma",
  message,
  confirmLabel = "Conferma",
  cancelLabel = "Annulla",
  onConfirm,
  onCancel,
  destructive = false,
  testid = "confirm-modal",
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      onClick={onCancel}
      data-testid={`${testid}-backdrop`}
    >
      <div
        className="bg-white rounded-[12px] w-full max-w-md p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-bold text-[#0A0A0A]" style={{ fontFamily: "Outfit" }}>
            {title}
          </h3>
          <button onClick={onCancel} data-testid={`${testid}-close`}>
            <X size={18} className="text-gray-400" />
          </button>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">{message}</p>
        <div className="mt-6 flex gap-3 justify-end">
          <button className="vg-btn-secondary" onClick={onCancel} data-testid={`${testid}-cancel`}>
            {cancelLabel}
          </button>
          <button
            className={destructive ? "vg-btn-primary" : "vg-btn-primary"}
            onClick={onConfirm}
            data-testid={`${testid}-confirm`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
